/**
 *
 *
 */

import RiskFactor from './risk-factor';

export default class AVSMessage extends RiskFactor {
    icon = 'map-marker';

    label = '<span class="has-tooltip has-tooltip-help" data-tooltip="Address Verification System">AVS</span> Message';

    static getCondition({avsResponse}) {
        return !!avsResponse && avsResponse.message !== null;
    }

    parse({avsResponse}) {
        this.avsResponse = avsResponse;
    }

    getResult() {
        return this.avsResponse.message;
    }
}
